<template>
  <div class="receipt-list" style="min-height: 300px">
    <div style="margin-bottom: 20px">
      <span v-if="isShow || true">
        <el-upload
          action=""
          multiple
          :show-file-list="false"
          :http-request="uploadaction"
          style="display: inline-block;margin: 0 10px 0 0"
        >
          <el-button type="primary">上传回单</el-button>
        </el-upload>
      </span>
      <el-button type="primary" @click="downFiles">
        下载回单
      </el-button>
    </div>
    <el-table v-loading="tableLoading" :data="tableData" border style="width: 100%" row-key="id" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="left" />
      <el-table-column prop="fileName" label="文件名称" align="left">
        <template v-slot="{row}">
          <el-button type="text" @click="openOrderBack(row.fileToken)">
            {{ row.fileName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" label="上传人" align="left" />
      <el-table-column prop="createTime" label="上传时间" align="left" min-width="100px" />
      <el-table-column prop="pname" label="操作" align="left">
        <template v-slot="{row}">
          <el-button type="text" @click="deleteReceive(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </div>
</template>

<script>
import { getReceiptEnclosureList, getTokenForDownZip, attachmentGetToken, uploadReceiptSaveInfo, deleteReceiptEnclosureList, getUrlByFileID } from '@/API/index.js';
import AxiosApi from '@/API/fileAxios';
export default {
  name: 'ReceiptList',
  data () {
    return {
      tableData: [],
      tableLoading: false,
      fileserveDownUrl: '',
      token: '',
      uploadUrl: '',
      downFileUrl: '',
      fileList: []
    };
  },
  props: {
    receiptForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openContract (fileToken) {

    },
    downFiles () {
      if (!this.multipleSelection.length) {
        this.$notify({
          title: '请至少选择一个文件',
          type: 'warning'
        });
        return;
      }
      if (this.multipleSelection.length === 1) {
        this.downOneFile(this.multipleSelection[0].fileToken);
      } else {
        let fileIds = [];
        this.multipleSelection.forEach((item) => {
          fileIds.push(item.fileToken);
        });
        getTokenForDownZip({
          catalogName: '回单附件集合',
          fileIds
        }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.downzipFile(json.data.token, json.data.downloadZipUrl);
          }
        }).catch(() => {

        });
      }
    },
    downOneFile (id) {
      this.fileserveDownUrl = this.downFileUrl + `/${id}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    downzipFile (token, url) {
      this.fileserveDownUrl = url + `?Token=${token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    submitfile (files) {
      this.tableLoading = true;
      uploadReceiptSaveInfo(files).then((res) => {
        let json = res.data;
        this.tableLoading = false;
        if (json.status === '200') {
          this.initData();
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    uploadaction (upload) {
      let form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      let myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };
      this.fileList.push(myfile);
      AxiosApi.post(this.uploadUrl + `?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.submitfile([{
            fileName: json.data[0].FullName,
            fileToken: json.data[0].FID,
            ecpPoDocumentId: this.receiptForm.DocumentID,
            receiptNumber: this.receiptForm.ReceiptNumber
          }]);
          myfile.loading = false;
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    initData () {
      if (this.receiptForm.DocumentID) {
        getReceiptEnclosureList(this.receiptForm.DocumentID, this.receiptForm.ReceiptNumber).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.tableData = json.data;
          }
        }).catch((res) => {

        });
      }
    },
    deleteReceive (row) {
      let idList = [];
      idList.push(row.enclosureID);
      deleteReceiptEnclosureList(idList).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('删除成功');
          this.initData();
        }
      }).catch((res) => {
        this.$message.warning('删除失败');
      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    openOrderBack (fileToken) {
      getUrlByFileID(fileToken).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          window.open(json.data);
        }
      }).catch((res) => {

      });
    }
  },
  mounted () {
    this.initData();
    this.initToken();
  }
};
</script>

<style scoped>

</style>
